import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useCampaignContestValues } from '@pages/Traders-Room/Campaign-Results/Contest/hooks/useCampaignContestValues'

import { SortOrder } from '@utils/ApiClient'

import { ClientContestCampaignDetailDto } from '@model/ClientContestCampaignDetailDto'

export const useCampaignContestSort = (campaign?: ClientContestCampaignDetailDto) => {
  const { t } = useTranslation()
  const { getCampaignContestPointsValue } = useCampaignContestValues(campaign)
  const [sort, setSort] = useState<string>()
  const [sortOrder, setSortOrder] = useState<SortOrder>()

  const sortOptions = [
    { id: 'Rank', name: t('Campaigns.Ranking') },
    { id: 'ClientTradingAccount.Name', name: t('Campaigns.Account Number') },
    { id: 'ContestPoints', name: getCampaignContestPointsValue() },
  ]

  return {
    getSortName: () => sortOptions.find((x) => x.id === sort)?.name,
    setSort,
    sort,
    sortOrder,
    setSortOrder,
    sortOptions,
  }
}
